import moment from 'moment';

export const formatCategory = category => category ? category.split('_').join(' ') : '-';

export const formatDateTime = date => moment(date).format('DD/MM/YYY hh:mm A')

export const formatDate = date => moment(date).format('DD/MM/YYY')

export const formatIsoDate = date => moment(date).format('YYYY-MM-DD h:mm:ss a');